import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { getSellers, Seller } from "@api/apiClient/sellers";
// import { Button, ButtonSize } from "@components/new/Button";
// import { H4, Title3 } from "@components/new/Typo";
import Skeleton from "@components/new/Skeleton";
import Store from "../components/Store/Store";
import { NoData } from "@components/new/NoData";
import styles from "./storetabs.module.scss";

const StoreTab = ({ openAddModal }: { openAddModal: () => void }) => {
  const { t } = useTranslation();

  const { isFetching, data } = useQuery({
    queryKey: ["sellers"],
    queryFn: () => getSellers(),
    retry: 1,
  });

  if (!data?.items.length) {
    return (
      <NoData
        title={t("storesPage.noData")}
        description={t("storesPage.noDataDescription")}
        btnTitle={t("storesPage.addShop")}
        onClick={openAddModal}
      />
    );
  }

  if (isFetching) {
    return (
      <div className={styles.stores}>
        <Skeleton width="100%" height="70px" />
        <Skeleton width="100%" height="70px" />
        <Skeleton width="100%" height="70px" />
        <Skeleton width="100%" height="70px" />
      </div>
    );
  }

  return (
    <div className={styles.stores}>
      {data?.items.map((item: Seller, index: number) => (
        <Store key={index} seller={item} />
      ))}
    </div>
  );
};

export default StoreTab;
